import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../../../domain/widget/model/widget-detail';
import {DomainUrlService} from '../../../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../../../application/app-context/user-context/user-context.service';
import {AmplitudeService} from '../../../../../../../../application/analytics/service/amplitude.service';
import {SubcategoryWithArticles} from '../../../../../../../../domain/publications/model/subcategory-with-articles';
import {Article} from '../../../../../../../../domain/publications/model/article';

@Component({
             selector: 'app-widget-publication-latest-videos-xlarge',
             templateUrl: './home-dashboard-widget-publication-latest-videos-xlarge.component.html'
           })
export class HomeDashboardWidgetPublicationLatestVideosXlargeComponent implements OnInit {

  readonly TRACK_ACTION_CLICK_LAST_VIDEO_ITEM = 'Widget_VideosXLarge_DisplayVideoArticle';
  readonly TRACK_ACTION_CLICK_CHANGE_DISPLAYED_VIDEO = 'Widget_VideosXLarge_ChangeDisplayedVideo';
  readonly TRACK_ACTION_CLICK_DISPLAY_ALL_VIDEOS = 'Widget_VideosXLarge_DisplayAllVideos';

  @Input() widget: WidgetDetail | undefined;
  @Input() articlesWithVideo: Array<Article> | undefined;
  @Output() actionEvent = new EventEmitter<string>();

  currentArticle: Article;
  accountId: string;
  publicationUrl: string;
  faTvUrl: string;

  constructor(private domainUrlService: DomainUrlService,
              private userContextService: UserContextService,
              private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.currentArticle = this.articlesWithVideo[0];
    this.accountId = this.userContextService.getUserContext().accountId;
    this.publicationUrl = this.domainUrlService.getPublicationUrl();
    this.faTvUrl = this.publicationUrl.concat('/decryptages-video/');
  }

  onClickTrackActionFATV(): void {
    const eventProperties = new Map<string, string>();
    this.amplitudeService.trackEventProperties(this.TRACK_ACTION_CLICK_DISPLAY_ALL_VIDEOS, eventProperties);
  }

  setCurrentArticle(selectedArticle :Article) {
    this.currentArticle = selectedArticle;

    const eventProperties = new Map<string, string>();
    eventProperties.set('Titre', this.currentArticle.title);
    eventProperties.set('Catégorie', this.currentArticle.categoryUid);
    eventProperties.set('Sous catégorie', this.currentArticle.subcategoryUid);
    this.amplitudeService.trackEventProperties(this.TRACK_ACTION_CLICK_CHANGE_DISPLAYED_VIDEO, eventProperties);
  }
}
